import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import NavbarWrapper from './navbarWrapper';
import Drawer from './drawer';
//import Button from './button';
import HamburgMenu from './hamburgmenu';
import ScrollSpyMenu from './scrollspymenu';
import Logo from './logo'
//import CopyrightSection from './copyrights';
import LogoImage from '../images/logo.png';
import { DrawerContext } from '../contexts/DrawerContext';
import data from '../data/';

const Container = styled.div`
  margin-left: auto;
  margin-right: auto;
  padding-left: 25px;
  padding-right: 25px;
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: space-between;
  @media (min-width: 320px) {
    padding-left: 25px;
    padding-right: 23px;
  }
  @media (min-width: 768px) {
    max-width: 750px;
  }
  @media (min-width: 992px) {
    max-width: 970px;
  }
  @media (min-width: 1200px) {
    max-width: 1170px;
  }
  .hamburgMenu__bar {
    margin-right: 5%;
  }
`;

const Navbar = ({ navbarStyle, logoStyle }) => {
  const { state, dispatch } = useContext(DrawerContext);
  // Toggle drawer
  const toggleHandler = () => {
    dispatch({
      type: 'TOGGLE',
    });
  };

  return (
    <NavbarWrapper {...navbarStyle}>
      <Container>
        <Logo
          href="#"
          logoSrc={LogoImage}
          title=""
          logoStyle={logoStyle}
        />
        <div style={{ display: 'flex', alignItems: 'right'}}>
          <Drawer
            width="420px"
            placement="right"
            drawerHandler={<HamburgMenu />}
            open={state.isOpen}
            toggleHandler={toggleHandler}
          >
            <ScrollSpyMenu
              menuItems={data.menuItems}
              drawerClose={true}
              offset={-100}
            />
          </Drawer>
        </div>
      </Container>
    </NavbarWrapper>
  );
};

// Navbar style props
Navbar.propTypes = {
  navbarStyle: PropTypes.object,
  logoStyle: PropTypes.object,
};

Navbar.defaultProps = {
  // Default navbar style
  navbarStyle: {
    minHeight: '70px',
  },
  // Default logo size
  logoStyle: {
    width: '115px',
    height: 'auto',
  },
};

export default Navbar;
